import CheckboxSelectAll from "@stimulus-components/checkbox-select-all"

export default class extends CheckboxSelectAll {
  private lastClickedIndex: number | null = null
  private lastClickedState: boolean | null = null

  initialize() {
    super.initialize();
    this.click = this.click.bind(this);
    this.lastClickedIndex = null
    this.lastClickedState = null
  }

  checkboxTargetConnected(checkbox: HTMLInputElement): void {
    super.checkboxTargetConnected(checkbox)
    checkbox.addEventListener("click", this.click)
  }

  checkboxTargetDisconnected(checkbox: HTMLInputElement): void {
    checkbox.removeEventListener("click", this.click)
    super.checkboxTargetDisconnected(checkbox)
  }

  toggle(e: Event): void {
    // Reset shift-click tracking when using the "select all" checkbox
    this.lastClickedIndex = null
    this.lastClickedState = null
    super.toggle(e)

    this.refresh();
  }

  refresh(): void {
    // We don't want the current functionality of the select all box
    const checkboxesCount = this.checkboxTargets.length
    const checkboxesCheckedCount = this.checked.length

    this.fire_update_event()
  }

  click(e: MouseEvent): void {
    const checkbox = e.target as HTMLInputElement
    const currentIndex = this.checkboxTargets.indexOf(checkbox)

    if (e.shiftKey && this.lastClickedIndex !== null && this.lastClickedState !== null) {
      const start = Math.min(this.lastClickedIndex, currentIndex)
      const end = Math.max(this.lastClickedIndex, currentIndex)

      // Set all checkboxes in range to the state of the last clicked checkbox
      for (let i = start; i <= end; i++) {
        const targetCheckbox = this.checkboxTargets[i]
        targetCheckbox.checked = this.lastClickedState
        this.triggerInputEvent(targetCheckbox)
      }

      this.refresh()
    }

    this.lastClickedState = checkbox.checked
    this.lastClickedIndex = currentIndex
  }

  fire_update_event(): void {
    this.dispatch('update', { detail: { value: this.checked.length == 0 } })
  }
}
